import { CustomFieldType } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

interface CreateCustomFieldState {
  name: string;
  fieldType: CustomFieldType;
}

const formSlice = createGenericFormSlice({
  name: "createCustomField",
  initialState: {} as SliceState<CreateCustomFieldState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const createActivityReducer = formSlice.reducer;
export default createActivityReducer;
